import { useState } from "react";
import { chatAvatarUrl } from "../api/media";

/** Storefront avatar sizes and online marker with a local image fallback. */
export default function ChatAvatar({ chat, header = false }) {
  const source = chatAvatarUrl(chat);
  const [brokenSource, setBrokenSource] = useState(null);
  return <span className={`dk-chat-avatar${header ? " dk-chat-avatar--header" : ""}`}>
    <img src={source && source !== brokenSource ? source : "/images/chat/avatar.svg"}
      alt="" width={header ? 40 : 48} height={header ? 40 : 48}
      loading={header ? "eager" : "lazy"} decoding="async"
      onError={() => { if (source) setBrokenSource(source); }} />
    {chat?.isOnline === true && <span className="dk-chat-avatar-online" aria-label="آنلاین" />}
  </span>;
}
